import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManagementService, DeliveryPoiDto, MissionService, PointInterest, RouteSegment } from 'src/app/client-management/data-management';
import { PoiServiceService } from '../poi-service/poi-service.service';
import { MapService } from '../service/map.service';
import {animate, state, style, transition, trigger} from "@angular/animations";
import { CustomMultiSelectComponent } from 'src/app/utils/leaflet/custom-multi-select/custom-multi-select.component';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-directions',
  templateUrl: './directions.component.html',
  styleUrls: ['./directions.component.css'],
  animations: [
        trigger('fadeSlide', [
            state('in', style({ opacity: 1, transform: 'translateY(0)' })),
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-30px)' }),
                animate('300ms ease-out')
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
            ]),
        ])
    ]
})
export class DirectionsComponent implements OnInit {

  @ViewChild('customFromMultiSelect') customFromMultiSelect!: CustomMultiSelectComponent;
  @ViewChild('customToMultiSelect') customToMultiSelect!: CustomMultiSelectComponent;
  showDirections:boolean = false;
  fromFirstOption:string = "Départ";
  toFirstOption:string = "Arrivée";
  directionOptionsFrom: any[] = [];
  directionOptionsTo: any[] = [];
  directionFrom: PointInterest | null;
  directionTo: PointInterest | null;
  poiLoading:boolean= false;
  pois: PointInterest[] = [];
  disableTo:boolean = false;
  private fromMarkerAddedSubscription: Subscription;
  private toMarkerAddedSubscription: Subscription;
  routeSegment:RouteSegment; 

  constructor(public poiService:PoiServiceService,
              private mapService: MapService,
              private dataManagementService: DataManagementService,
              private missionService:MissionService,
              private toastr: ToastrService) { }

  ngOnInit(): void {

    if (this.dataManagementService.pointInterests) {
        this.pois = this.dataManagementService.pointInterests;
        this.directionOptionsFrom = [...this.fromPoiToDirection(this.pois)]
        this.directionOptionsTo = [...this.fromPoiToDirection(this.pois)]        
      } else {
        this.poiLoading = true;
        this.dataManagementService
          .getAllPointInterests()
          .subscribe({
            next: (pointInterests) => {
              this.dataManagementService.pointInterests = pointInterests;
              this.pois = pointInterests;
              this.directionOptionsFrom = [...this.fromPoiToDirection(this.pois)];
              this.directionOptionsTo = [...this.fromPoiToDirection(this.pois)];
              this.poiLoading = false;              
            },
            error:()=>{this.poiLoading = false}
          }           
        );
    }

    this.mapService.showDirections.subscribe({
            next:(show:boolean)=>{
                this.showDirections = show;
                if(!this.showDirections){
                    this.fromFirstOption= "Départ";
                    this.toFirstOption= "Arrivée";
                    this.directionFrom = null;
                    this.directionTo = null;
                }
            }
      })      
     this.fromAndToSubscription();     
  }

     
  fromPoiToDirection(poi: PointInterest[]) {
        return poi.map(item => ({
            id: item.idPointInterest,
            name: item.name
        }));
  }

  onSelectionFrom(id: number[]) {
        this.closeFromSelect();        
        if(id?.length > 0) {
            this.disableTo = false;            
            this.directionFrom = this.pois.find((poi) => poi.idPointInterest === id[0]);
            this.directionOptionsTo = [...this.fromPoiToDirection(this.pois.filter((poi) => Number(`1${poi.idPointInterest}`) !== id[0]))]            

            if (this.directionTo) {                
                this.mapService.clearPolylines();
                this.toFirstOption= "Arrivée";
            }
        }
    }

    onSelectionTo(id: number[]) {
        this.closeToSelect();        
        if(id?.length > 0) {            
          this.directionTo = this.pois.find((poi) => poi.idPointInterest === id[0]);                                    
          if (this.directionFrom && this.directionTo ) {                            
            const from = {lat:this.directionFrom.coordinate.lat,lng:this.directionFrom.coordinate.lng,name:this.directionFrom.address};
            const to = {lat:this.directionTo.coordinate.lat,lng:this.directionTo.coordinate.lng,name:this.directionTo.address};            
            if (from && to && (from.lat !== to.lat || from.lng !== to.lng)) {                
                this.addRoute(from, to);
            }
            else {
                this.mapService.clearPolylines();                
            }
          }
        }
    }

    closeFromSelect() {
        if (this.customFromMultiSelect != undefined) this.customFromMultiSelect.closeDropdown();
    }
    closeToSelect(){
        if (this.customToMultiSelect != undefined) this.customToMultiSelect.closeDropdown();
    }

    chooseFromInMap(){
        if(this.poiService.getChooseToInMap()) this.poiService.setChooseToInMap(false);
        this.poiService.setChooseFromInMap(!this.poiService.getChooseFromInMap());
    }

    chooseToInMap(){
        if(this.poiService.getChooseFromInMap()) this.poiService.setChooseFromInMap(false);
        this.poiService.setChooseToInMap(!this.poiService.getChooseToInMap());
    }

    fromAndToSubscription(){
        this.fromMarkerAddedSubscription =
            this.mapService.fromMarkerAdded.subscribe((data) => {
                this.fromFirstOption = data.address;
                this.directionFrom = {
                    idPointInterest: 0,
                    name: data.address,
                    coordinate:{lat:data.position.lat,lng:data.position.lng},
                } as PointInterest;
                this.disableTo = false;
                if(this.directionTo && this.directionFrom){
                    const from = {lat:this.directionFrom.coordinate.lat,lng:this.directionFrom.coordinate.lng,name:this.directionFrom.address};
                    const to = {lat:this.directionTo.coordinate.lat,lng:this.directionTo.coordinate.lng,name:this.directionTo.address};
                    if (from && to && (from.lat !== to.lat || from.lng !== to.lng)) {                        
                        this.addRoute(from, to);
                    }                                      
                }
            });
        this.toMarkerAddedSubscription =
            this.mapService.toMarkerAdded.subscribe((data) => {
                this.toFirstOption = data.address;
                this.directionTo = {
                    idPointInterest: 0,
                    name: data.address,
                    coordinate:{lat:data.position.lat,lng:data.position.lng},
                } as PointInterest;
                if(this.directionFrom && this.directionTo){
                    const from = {lat:this.directionFrom.coordinate.lat,lng:this.directionFrom.coordinate.lng,name:this.directionFrom.address};
                    const to = {lat:this.directionTo.coordinate.lat,lng:this.directionTo.coordinate.lng,name:this.directionTo.address};
                    if (from && to && (from.lat !== to.lat || from.lng !== to.lng)) {                        
                        this.addRoute(from, to);
                    }
                }

            });
    }

    addRoute(from:{lat:number,lng:number,name:string},to:{lat:number,lng:number,name:string}){        
      let points : DeliveryPoiDto[]=[];
      points.push(from);
      points.push(to);
      this.missionService.getRouteSegments(points).subscribe({
        next:(data)=>{
          if(data && data.length > 0){
            this.routeSegment = data[0];
            const coords = data[0].coordinates.map(coord => ({
              lat: coord[1],
              lng: coord[0]
            }));            
            this.mapService.drawRoute(points,coords)
          }          
        },
        error:()=>{
          this.toastr.error('Error get directions', 'Sorry!', {
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: 10000
          });          
        }
      })
    }

    formatDuration(seconds: number): string {
        const days = Math.floor(seconds / 86400);
        seconds %= 86400;
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);

        let result = '';
        if (days > 0) result += `${days} j `;
        if (hours > 0) result += `${hours} h `;
        if (minutes > 0) result += `${minutes} min `;

        return result.trim();
    }

    formatDistance(meters: number): string {
        const km = meters / 1000;
        return km.toFixed(2).replace('.', ',') + ' km';
    }
}
